import './ZeroBrokerage.css';

const ZeroBrokerage = () => {
  return (
    <section className="zero-brokerage">
      <div className="zero-brokerage-container">
        <div className="zero-brokerage-content">
          <h2 className="section-title">Enjoy Maximum Profits with Low BROKERAGE</h2>
          <p className="section-description">
            Is money-making your passion? Our platform makes trading easy and fun.
            Trade anytime, anywhere, on any device with absolute LOW BROKERAGE costs
          </p>
        </div>
      </div>
    </section>
  );
};

export default ZeroBrokerage;
